import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { CardContent, Divider, Grid, Typography } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import { OrganizationChart } from './pages/OrganizationChart';
import { Procedures } from './pages/Procedures';

export const StructureProcedure = () => {
  const theme = useTheme();

  return (
    <>
      <MainCard
        style={{ marginTop: '20px', paddingBottom: '5px' }}
        title={
          <Grid container justifyContent={'center'} alignItems={'center'}>
            <Grid item xs={12}>
              <Typography variant="h1" component="h2">
                Estructura & Procedimiento
              </Typography>
              <Typography variant="h4"> Gobernanza y Procedimientos </Typography>
            </Grid>
          </Grid>
        }
        secondary={
          <Grid container justifyContent={'center'}>
            <Box>
              <AccountTreeIcon sx={{ fontSize: '60px' }} color={theme.palette.grey[500]} />
            </Box>
          </Grid>
        }
      >
        <CardContent>
          <Grid container justifyContent={'center'} alignItems={'center'}>
            <Grid item xs={12}>
              <Typography align="center" variant="h2" component="h3">
                Estructura de la alianza
              </Typography>
              <Typography align="center"> Gobernanza y Procedimientos </Typography>
            </Grid>
            <Grid item xs={12} sx={{ marginBottom: 2 }}>
              <OrganizationChart />
            </Grid>
            <Grid item xs={12}>
              <Typography align="right"> Acuerdo de Alianza Estratégica Google </Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{ marginTop: 2, marginBottom: 5 }} />
            </Grid>
          </Grid>

          <Grid container justifyContent={'center'} alignItems={'center'}>
            <Grid item xs={12}>
              <Typography align="center" variant="h2" component="h3">
                Procedimiento de compra
              </Typography>
              <Typography align="center"> Google - Fondos GoES </Typography>
            </Grid>
            <Grid item xs={12}>
              <Procedures />
            </Grid>
            <Grid item xs={12}>
              <Typography align="right"> Acuerdo de Alianza Estratégica Google </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </MainCard>
    </>
  );
};
